import axios from 'axios';
import _ from 'lodash';

/**
 * Configure axios instance to call API
 */
const api = axios.create({
  baseURL: '/',
  timeout: 30000,
  headers: {
    post: {
      'Content-Type': 'application/json',
    },
    common: {
      'Accept': 'application/json', // eslint-disable-line quote-props
    },
    'X-Requested-With': 'XMLHttpRequest',
  },
});

api.interceptors.response.use((response) => {
  // Do something with response data
  return response;
}, (error) => {
  // Do something with response error
  if (error.response) {
    if (error.response.status && error.response.status === 401) {
      //Redirect to login page as there is no session (PHP session timeout scenario)
      window.location.assign('/login');
      return Promise.reject(error);
    }

    if (error.response.status === 404) {
      error.response = createGlobalErrorObj([
        'The page or entity you requested does not exist.',
      ]);
    }
  } else if (error.code === 'ECONNABORTED') {
    let message = `Unfortunately, your request took longer than ${error.config.timeout / 1000}s, please modify your request or try again`;
    error.response = createGlobalErrorObj([message]);
  } else {
    error.response = createGlobalErrorObj();
  }

  logger(error);
  return Promise.reject(error);
});

export default api;

export function setApiDefaults(defaults, api) {
  (api || axios).defaults = _.extend(axios.defaults, defaults);
}

const logger = (error) => {
  if (window.Rollbar) {
    //Prune sensitive data before sending to rollbar
    if (_.has(error, 'response.config.data') && typeof(error.response.config.data) !== 'undefined') {
      try {
        let data = JSON.parse(error.response.config.data);
        const sensitiveKeys = ['password', 'passwords', 'username', 'email', 'usercompany'];
        for (var key in data) {
          if (sensitiveKeys.indexOf(key.toLowerCase()) > -1) {
            delete data[key];
          }
        }
        error.response.config.data = JSON.stringify(data);
      } catch (error) {
        //nothing to do
        (() => {})();
      }

    }

    return new Promise(function () {
      if (_.has(error, 'response.data.VISIT_ID')) {
        window.Rollbar.log(error.response.data.VISIT_ID);
      }

      window.Rollbar.error(error.message || 'API error received by React', error);
    });
  }
};

export const createGlobalErrorObj = (errorMessages = []) => {
  let newError = _.cloneDeep(errorObj);
  newError.data.error[0].fields[0].messages = errorMessages.map((msg) => ({
    text: msg,
  }));
  return newError;
};

export const errorObj = {
  data: {
    error: [
      {
        name: 'global',
        fields: [
          {
            name: 'global',
            messages: [
              {
                text: 'An internal error occurred and we are unable to complete your request.',
              },
            ],
          },
        ],
      },
    ],
  },
};
